<script setup lang="ts">
import { computed } from 'vue'

import type { LinkBreadcrumbItem } from '@shared/ui/menus'

import { AppRoute } from '@shared/config'
import { NavigationBreadcrumbs } from '@shared/ui/menus'

defineOptions({
  name: 'TasksKanbanHeader',
})

const config = computed<LinkBreadcrumbItem[]>(() => [
  {
    id: 'tasks-kanban',
    text: 'Tasks Kanban',
    to: AppRoute.TasksKanbanSupport,
    disabled: true,
  },
])
</script>

<template>
  <NavigationBreadcrumbs :config="config" />
</template>
